// extracted by mini-css-extract-plugin
export default {"socialContact":"SocialContact_socialContact__NOzu9","socialContactContainer":"SocialContact_socialContactContainer__zjCpa","socialIcons":"SocialContact_socialIcons__XqSj6"};